export default __webpack_public_path__ + "static/media/botao_excluir_rid.23013c42.svg";